module.exports = __webpack_public_path__ + "static/media/productos_otros_pistache.41be8df3.jpg";